<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
        <div class="row">
          <app-form-group label="Type of activities">
            <app-select [(ngModel)]="exemption.activityType" id="activityType" [options]="activityTypes" required>
            </app-select>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Specification of activities">
            <textarea [(ngModel)]="exemption.activitySpecification" id="activitySpecification" type="text" rows="3"
                      minlength="20" maxlength="1024" class="form-control" required></textarea>
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="Location on board">
            <app-select [(ngModel)]="exemption.locationOnBoard" id="locationOnBoard"
                        [options]="locationTypes" required>
            </app-select>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Description of exact location of work">
            <textarea [(ngModel)]="exemption.locationExact" id="locationExact" type="text" rows="3" minlength="20"
                      maxlength="1024" class="form-control" required></textarea>
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>From</label>
              <div class="tooltipContent">Start and end date of operations</div>
            </app-info>
            <app-date-field [(ngModel)]="exemption.from" id="from" required></app-date-field>
          </app-form-group>
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>To</label>
              <div class="tooltipContent">Start and end date of operations</div>
            </app-info>
            <app-date-field [(ngModel)]="exemption.to" id="to" required></app-date-field>
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="Executor of activities">
            <app-select [(ngModel)]="exemption.executorType" id="executorType" [options]="executorTypes" required>
            </app-select>
          </app-form-group>
        </div>
        <div class="row">
          @if (exemption.executorType === OTHER) {
            <app-form-group label="Other">
              <input [(ngModel)]="exemption.executorTypeOther" (ngModelChange)="resetExecutorTypeOther()"
                     id="executorTypeOther" type="text" maxlength="256"
                     class="form-control" required>
            </app-form-group>
          }
        </div>

        <div class="row">
          <app-form-group label="Does the vessel continue to have propulsive power ?">
            <app-yes-no [(ngModel)]="exemption.continueToHavePropulsivePower" id="continueToHavePropulsivePower"
                        required></app-yes-no>
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="What fuel does the propulsion use ?">
            <app-select [(ngModel)]="exemption.fuelType" (ngModelChange)="resetFuelTypeOther()" id="fuelType"
                        [options]="fuelTypes" required>
            </app-select>
          </app-form-group>
        </div>
        <div class="row">
          @if (exemption.fuelType === OTHER) {
            <app-form-group label="Other">
              <input [(ngModel)]="exemption.fuelTypeOther" id="fuelTypeOther" type="text" maxlength="256"
                     class="form-control" required>
            </app-form-group>
          }
        </div>
      </div>

      <div class="col-md fieldset">
        <div class="row">
          <app-form-group
            label="Is a repair carried out within 25 meters of the (fuel) tank and/or engine and/or flammable materials and/or dangerous cargo ?">
            <app-yes-no [(ngModel)]="exemption.repair25MetersOf" (ngModelChange)="resetFieldsRelateToRepair25MetersOf()"
                        id="repair25MetersOf" required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          @if (exemption.repair25MetersOf) {
            <app-form-group
              label="Has a health and safety certificate been issued by a recognised gas expert ?">
              <app-yes-no [(ngModel)]="exemption.hasCertificateIssued" id="hasCertificateIssued" required></app-yes-no>
            </app-form-group>
          }
        </div>

        <div class="row">
          <app-form-group label="Is work being carried out on the installation or on the tank itself ?">
            <app-yes-no [(ngModel)]="exemption.workOnInstallationOrOnTank"
                        (ngModelChange)="resetFieldsRelateToWorkOnInstallationOrOnTank()"
                        id="workOnInstallationOrOnTank" required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          @if (exemption.workOnInstallationOrOnTank) {
            <app-form-group label="How much fuel is on board ? (m3)">
              <input [(ngModel)]="exemption.fuelOnBoard" id="fuelOnBoard" type="number" maxlength="32"
                     class="form-control">
            </app-form-group>
          }
          @if (exemption.workOnInstallationOrOnTank) {
            <app-form-group
              label="What is the pressure in the tanks ? (Bar)">
              <input [(ngModel)]="exemption.pressureInTheTank" id="pressureInTheTank" type="number" maxlength="32"
                     class="form-control">
            </app-form-group>
          }
          @if (exemption.workOnInstallationOrOnTank) {
            <app-form-group label="What is the MARV-setting ?">
              <input [(ngModel)]="exemption.marvSetting" id="marvSetting" type="text" maxlength="256"
                     class="form-control">
            </app-form-group>
          }
          @if (exemption.workOnInstallationOrOnTank) {
            <app-form-group label="How is the Boil Off Control managed ?">
              <input [(ngModel)]="exemption.boilOffControlManagement" id="boilOffControlManagement" type="text"
                     minlength="20" maxlength="256" class="form-control">
            </app-form-group>
          }
          @if (exemption.workOnInstallationOrOnTank) {
            <app-form-group
              label="What control measures are taken to prevent an emission ?">
              <input [(ngModel)]="exemption.controlMeasuresTaken" id="controlMeasuresTaken" type="text" minlength="20"
                     maxlength="256" class="form-control">
            </app-form-group>
          }
        </div>

        <div class="row">
          <app-form-group label="Will repairing work take longer then 7 days">
            <app-yes-no [(ngModel)]="exemption.repairingMoreThanSevenDays"
                        (ngModelChange)="resetFieldsRelateToRepairingMoreThanSevenDays()"
                        id="repairingMoreThanSevenDays"></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          @if (exemption.repairingMoreThanSevenDays) {
            <app-form-group
              label="Is there a firefighter who holds VCA/SCC diploma and AV-011 fire-fighting certificate and supervises the repair work ?">
              <app-yes-no [(ngModel)]="exemption.thereIsFirefighter" id="thereIsFirefighter" required></app-yes-no>
            </app-form-group>
          }
          @if (exemption.repairingMoreThanSevenDays) {
            <app-form-group
              label="Is there permission from the owner of the berth ?">
              <app-yes-no [(ngModel)]="exemption.thereIsPermissionFromTheOwner" id="thereIsPermissionFromTheOwner"
                          required></app-yes-no>
            </app-form-group>
          }
          @if (exemption.repairingMoreThanSevenDays) {
            <app-form-group
              label="Is there a plan of action that includes an accurate indication of the duration of the total time of the work and any concurrent activities carried out during the work ?">
              <app-yes-no [(ngModel)]="exemption.thereIsPlanOfAction" id="thereIsPlanOfAction" required></app-yes-no>
            </app-form-group>
          }
        </div>

        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
